import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      marginTop: 24,
    },
    header: {
      ...theme.fonts.h4,
      color: theme.colors.textDefault,
    },
    userIdSection: {
      ...theme.fonts.p2,
      color: theme.colors.textSubtle,
      marginTop: 16,
    },
    userId: {
      marginLeft: 4,
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
